import { TextField as TextFieldMUI, TextFieldProps as TextFieldPropsMUI } from '@mui/material'
import { FieldContainer } from '../functional'
import useCheckAutoFill from '../../hooks/useCheckAutoFill'
import {
   PatternFormat,
   NumericFormat,
   PatternFormatProps,
   NumericFormatProps,
} from 'react-number-format'

type TextFieldProps = TextFieldPropsMUI & {
   name: string
   patternFormat?: PatternFormatProps<any>
   numberFormat?: NumericFormatProps<any>
   highlight?: boolean
}

const Textfield: React.FC<TextFieldProps> = ({
   name,
   patternFormat,
   numberFormat,
   highlight,
   ...props
}) => {
   const { hasAutoFill, onAnimationStart } = useCheckAutoFill()
   return (
      <FieldContainer name={name} highlight={highlight}>
         {({ value, onChange, ...fieldProps }) => {
            if (patternFormat) {
               return (
                  <PatternFormat
                     {...fieldProps}
                     {...patternFormat}
                     customInput={TextFieldMUI}
                     onValueChange={(values) => {
                        onChange({
                           target: {
                              name,
                              value: values.value,
                           },
                        })
                     }}
                     fullWidth
                     disabled={props.disabled || fieldProps.disabled}
                     InputLabelProps={{ shrink: !!value || hasAutoFill }}
                     inputProps={{ onAnimationStart, ...props.inputProps }}
                     label={props.label}
                     value={value}
                     type="text"
                  />
               )
            }

            if (numberFormat) {
               return (
                  <NumericFormat
                     {...fieldProps}
                     {...numberFormat}
                     fullWidth
                     disabled={props.disabled || fieldProps.disabled}
                     InputLabelProps={{ shrink: !!value || hasAutoFill }}
                     customInput={TextFieldMUI}
                     inputProps={{
                        onAnimationStart,
                        inputMode: 'numeric',
                        ...props.inputProps,
                     }}
                     value={value}
                     onValueChange={(values) => {
                        onChange({
                           target: {
                              name,
                              value: values.value,
                           },
                        })
                     }}
                     label={props.label}
                  />
               )
            }
            return (
               <TextFieldMUI
                  {...fieldProps}
                  onChange={onChange}
                  value={value}
                  size="medium"
                  fullWidth
                  disabled={props.disabled || fieldProps.disabled}
                  InputLabelProps={{ shrink: !!value || hasAutoFill }}
                  inputProps={{ onAnimationStart, ...props.inputProps }}
                  {...props}
               />
            )
         }}
      </FieldContainer>
   )
}

export default Textfield
